// extracted by mini-css-extract-plugin
module.exports = {"launchGRDWelcome":"style_launchGRDWelcome__lQqQH","welcomeGRDBlock":"style_welcomeGRDBlock__1rJC3"};